const SaveButton = ({onClick, text}) => {
    return <button className="btn btn-sm btn-primary ml-1 mr-1" onClick={onClick}>
        <i className="fas fa-save" />&nbsp;&nbsp;&nbsp;{text}
    </button>
};

export default SaveButton;
